import { render, staticRenderFns } from "./interpolation-extension.vue?vue&type=template&id=36be5b94&scoped=true"
import script from "./interpolation-extension.vue?vue&type=script&lang=js"
export * from "./interpolation-extension.vue?vue&type=script&lang=js"
import style0 from "./interpolation-extension.vue?vue&type=style&index=0&id=36be5b94&prod&lang=less&scoped=true"
import style1 from "./interpolation-extension.vue?vue&type=style&index=1&id=36be5b94&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36be5b94",
  null
  
)

export default component.exports